<template>
	<div class="body">
		<el-container>
			
			<el-header>
				<HeaderCus></HeaderCus>
			</el-header>
			
			<el-main style="height: 730px;">
				<div class="content_main" style="background-color: #fff; padding: 120px 0;">
					<div class="login_main">
						<el-row>
							<el-col :span="20" :offset="2">
								<div class="login_qrcode">
									<div class="login_qrcode_title">
										微信扫码登录
									</div>
									<div class="login_qrcode_img">
										<el-image :src="login_qrcode" fit="contain" style="width: 250px;">
											<div slot="error" class="image-slot">
											</div>
										</el-image>
										<div class="login_qrcode_summary">
											打开手机微信扫一扫 登录/注册
										</div>
									</div>
									
									<div class="login_qrcode_note">
										温馨提示：<br/>
										1、首次扫码需要关注“强企宝典”公众号后自动登录<br/>
										2、二维码有效期3分钟，超时后请重新获取<br/>
										3、在注册或登录本平台前请您仔细阅读<a href="#/detail_article?id=131" target="_blank">用户协议</a><br/>
										4、您的注册或登录视为接受该上述用户协议<br/>
										<!-- 请确认使用同一个微信号；请确认关注了“强企宝典”服务号；<br/>
										还有问题，请联系我们； -->
									</div>
								</div>
							</el-col>
							<!-- <el-col :span="6":offset="3">
								<div class="login_image">
									<div class="login_image_text">
										企业发展导航<br/>
										老板圆梦陪伴<br/>
										服务能力提升<br/>
										学者深度学习<br/>
										政府梯次培育<br/>
									</div>
								</div>
							</el-col> -->
						</el-row>
					</div>
				</div>
			</el-main>
			
			<el-footer>
				<FooterCus></FooterCus>
			</el-footer>
			
		</el-container>
	</div>
</template>

<script>
	import HeaderCus from '../components/header.vue'
	import FooterCus from '../components/footer.vue'
	export default {
		components: {
			HeaderCus,
			FooterCus,
		},
		data() {
			return {
				login_uuid: '',
				login_qrcode: '',
				count: 0,
			}
		},
		
		created() {
			this.createQrcode()
		},
		
		mounted() {
			this.$router.beforeEach((to, from, next) => {
				// console.log(to, from)
				if (to.meta.title) {
					document.title = to.meta.title
				}
				next()
			})
		},
		
		methods: {
			// 创建登录二维码
			createQrcode() {
				let url = 'http://sudomanage.qqbd.vip/api/wx/mp/biz/wxe4ad8c0c1dc709c6/createQrcode'
				// let url = 'http://localhost:58080/api/wx/mp/biz/wxe4ad8c0c1dc709c6/createQrcode' // 如果使用本地测试，出现二维码后修改数据库is_scan和scan_user_id字段用于模拟用户扫码登录
				this.$axios.get(url).then((res)=>{
					console.log(res.data.data)
					this.login_uuid = res.data.data.uuid
					this.login_qrcode = res.data.data.url
					this.checkQrcode()
				})
			},
			
			// 定时监测二维码状态是否扫描更新
			checkQrcode() {
				let task = setInterval(() => {
					this.count += 1
					let url = this.$common.apiUrl + 'pub_login_qrcode/detail/' + this.login_uuid
					this.$axios.get(url).then((res)=>{
						// console.log('扫码数据：',res.data.data)
						let status = res.data.data.isScan
						if (status == '1') {
							console.log('is_scan')
							clearInterval(task)
							let scan_user_id = res.data.data.scanUserId
							this.saveUser(scan_user_id) // 获取用户信息并保存
						} else {
							// console.log('未扫码')
							console.log(this.count)
							if (this.count >= 90) {
								console.log('已超时，停止获取二维码数据')
								clearInterval(task)
							}
						}
					})
				}, 2000)
			},
			
			// 获取用户信息并保存在localstorage
			saveUser(user_id) {
				// console.log('用户id：',user_id)
				let url = this.$common.apiUrl + 'pub_user/detail/' + user_id
				this.$axios.get(url).then((res)=>{
					// console.log(res.data.data)
					let cur_user = res.data.data
					console.log('扫码用户数据：', cur_user)
					localStorage.setItem('cur_user', JSON.stringify(cur_user))
					console.log('用户状态已保存1', localStorage.getItem('cur_user'))
					console.log('用户状态已保存2', JSON.parse(localStorage.getItem('cur_user')))
					
					let from_url = localStorage.getItem('from_url')
					if (from_url != null) {
						this.$router.push({path: from_url})
					} else {
						this.$router.push({path: '/'})
					}
					
				})
			},
			
			
			
		}
	}
</script>

<style scoped>
</style>